// Audio Alarm service using Web Audio API

let audioCtx = null;

function getAudioContext() {
  if (!audioCtx) {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (AudioContextClass) {
      audioCtx = new AudioContextClass();
    }
  }
  if (audioCtx && audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

// Auto unlock audio context on first user interaction
if (typeof window !== 'undefined') {
  const unlockAudio = () => {
    try {
      const ctx = getAudioContext();
      if (ctx && ctx.state === 'suspended') {
        ctx.resume();
      }
    } catch (e) {}
    window.removeEventListener('click', unlockAudio);
    window.removeEventListener('touchstart', unlockAudio);
    window.removeEventListener('keydown', unlockAudio);
  };
  window.addEventListener('click', unlockAudio, { once: true });
  window.addEventListener('touchstart', unlockAudio, { once: true });
  window.addEventListener('keydown', unlockAudio, { once: true });
}

/**
 * Schedule a single crisp, dual-tone alert chime pulse
 */
function scheduleChimePulse(ctx, startTime) {
  const osc1 = ctx.createOscillator();
  const osc2 = ctx.createOscillator();
  const gain = ctx.createGain();

  osc1.type = 'sine';
  osc2.type = 'triangle';

  // Melodic rising chime sequence: A5 (880Hz) -> D6 (1174.66Hz)
  osc1.frequency.setValueAtTime(880, startTime);
  osc1.frequency.setValueAtTime(1174.66, startTime + 0.12);
  osc1.frequency.setValueAtTime(1318.51, startTime + 0.24);

  // Harmonic bass support: A4 (440Hz) -> D5 (587.33Hz)
  osc2.frequency.setValueAtTime(440, startTime);
  osc2.frequency.setValueAtTime(587.33, startTime + 0.12);
  osc2.frequency.setValueAtTime(659.25, startTime + 0.24);

  // Smooth attack & decay volume envelope
  gain.gain.setValueAtTime(0.01, startTime);
  gain.gain.linearRampToValueAtTime(0.35, startTime + 0.03);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.55);

  osc1.connect(gain);
  osc2.connect(gain);
  gain.connect(ctx.destination);

  osc1.start(startTime);
  osc2.start(startTime);
  osc1.stop(startTime + 0.55);
  osc2.stop(startTime + 0.55);
}

/**
 * Play alarm sound with multi-repeat chime (default: 3 repetitions for alarms/signals)
 * @param {string} type - 'alarm' | 'signal' | 'beep'
 * @param {number} repeats - number of times to chime (default 3 for alarms, 1 for beep)
 */
export function playAlarmSound(type = 'alarm', repeats = 3) {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    const now = ctx.currentTime;

    if (type === 'alarm' || type === 'signal') {
      const chimeCount = Math.max(1, Math.min(repeats || 3, 5));
      const spacingSeconds = 0.68; // 680ms between chime bursts

      for (let i = 0; i < chimeCount; i++) {
        scheduleChimePulse(ctx, now + i * spacingSeconds);
      }
    } else if (type === 'beep') {
      // Quick gentle tick/ping
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(1200, now);
      gain.gain.setValueAtTime(0.2, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start(now);
      osc.stop(now + 0.18);
    }
  } catch (err) {
    console.warn('Audio alarm playback error:', err);
  }
}